module.exports = __webpack_public_path__ + "img/logo-long.5bf11618.png";